import { Component, OnInit, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';


@Component({
  selector: 'app-video-tool-header',
  templateUrl: './video-tool-header.component.html',
  styleUrls: ['./video-tool-header.component.scss']
})
export class VideoToolHeaderComponent implements OnInit {

  @Input()
  menuConfig: any[];

  @Input()
  userInfo: any;

  currentMenuId;
  logoutPage = true;

  constructor( public router: Router, public oktaAuth: OktaAuthService ) {

  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        /* istanbul ignore next */
        if (event.urlAfterRedirects.indexOf('logout') !== -1) {
          this.logoutPage = true;
        } else {
          this.logoutPage = false;
          this.setCurrentMenuID(event.urlAfterRedirects);
        }
      }
    });
  }

  setCurrentMenuID(url) {
    const currentMenu = this.menuConfig.find( (c) => (url ===  '/' + c.routerLink) ) // exact match
      || this.menuConfig.find( (c) => url.startsWith('/' + c.routerLink) ); // partial match
    /* istanbul ignore next */
    this.currentMenuId = currentMenu ? currentMenu.id : 1;
  }

  async logout() {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    const logoutURL = window.location.origin + '/videotool/logout';
    await this.oktaAuth.signOut({
      postLogoutRedirectUri: logoutURL
    });
  }
}
